import PropTypes from "prop-types";
import React, { useContext } from "react";
import _ from "lodash";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../../umbilical_tools";
import jssVariables from "../../../jss_setup";
import { inputGroupStyles } from "../widgets";

const paxPickerACCStyles = createUseStyles({
  PaxPickerACC: (props) => ({
    ...inputGroupStyles(),
    position: "relative",
    height: "100%",
    alignContent: "space-between",
    fontFamily: jssVariables.fontFamily,
    ..._.get(props, "customStyles.PaxPickerACC", {}),
  }),
  label: (props) => ({
    color: jssVariables.colors.text.dark,
    fontSize: "medium",
    ..._.get(props, "customStyles.label", {}),
  }),
  PaxBtn: (props) => ({
    borderRadius: "5px",
    height: "2.45rem",
    textAlign: "left",
    fontSize: "medium",
    background: "white",
    border: `1px solid ${jssVariables.colors.border}`,
    color: jssVariables.colors.text.dark,
    width: "100%",
    paddingLeft: jssVariables.normal_gap,
    ..._.get(props, "customStyles.paxBtn", {}),
  }),
});
export const PaxPickerACC = ({ customStyles, search_form, onClick, id }) => {
  const classes = paxPickerACCStyles({ customStyles });
  const { t } = useContext(TranslationContext);

  const rooms = _.get(search_form, "rooms.length", 0);
  let adults = 0;
  let childPax = 0;

  _.get(search_form, "rooms", []).forEach((room) => {
    adults += room.adults;
    childPax += room.children;
  });

  return (
    <div className={classes.PaxPickerACC}>
      <span className={classes.label}>{t("guests")}</span>
      <button
        id={id}
        className={classes.PaxBtn}
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}>
        {`${t("adults")}: ${adults} - ${t("children")}: ${childPax} - ${t(
          "rooms"
        )}: ${rooms}`}
      </button>
    </div>
  );
};
PaxPickerACC.defaultProps = {
  customStyles: {},
  search_form: {},
  id: "",
};
PaxPickerACC.propTypes = {
  id: PropTypes.string,
  customStyles: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  search_form: PropTypes.object.isRequired,
};
